import docPreviewPackageEN from "@neonumy/documents-preview/lib/resources/locales/en/docPreviewPackage.json";
import docPreviewPackageFR from "@neonumy/documents-preview/lib/resources/locales/fr/docPreviewPackage.json";
import neonumyUiTranslationsEn from "@neonumy/neonumy-ui/lib/resources/locales/en/neonumy-ui.json";
import neonumyUiTranslationsFr from "@neonumy/neonumy-ui/lib/resources/locales/fr/neonumy-ui.json";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "resources/i18n/locales/en/translation.json";
import translationFR from "resources/i18n/locales/fr/translation.json";

const resources = {
  en: {
    translation: translationEN,
    docPreviewPackage: docPreviewPackageEN,
    "neonumy-ui": neonumyUiTranslationsEn,
  },
  fr: {
    translation: translationFR,
    docPreviewPackage: docPreviewPackageFR,
    "neonumy-ui": neonumyUiTranslationsFr,
  },
};

export const langsCode = ["fr", "en"];

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("i18nextLng") || langsCode[0],
  fallbackLng: langsCode,
  keySeparator: false,
  interpolation: {
    escapeValue: false,
    // Nesting ($t(...)) isn't used by any translation in this app or its
    // packages. Dynamic content (e.g. activity/notification messages from
    // the backend) can coincidentally contain "$t(" and trigger i18next's
    // nesting resolution, which can recurse infinitely (Sentry NEOSCAN-PRO-ZT).
    // Redirecting the nesting delimiter to a string that never occurs in
    // practice disables that resolution entirely.
    nestingPrefix: "§§__NO_NESTING__(",
    nestingSuffix: ")",
  },
  ns: ["translation", "neonumy-ui", "docPreviewPackage"],
  defaultNS: "translation",
});

export const langsLabel = () => [i18n.t("French"), i18n.t("English")];
export default i18n;
